import React from "react";



export default function DeactivatedStudents() {
    return (
        <div>
            <h4><b>Deactivated Students</b></h4>
        </div>
    )
}
